export const eventHandlers = {
  CHECKOUT_HOSTED_PAYMENT_METHOD_PAGE_VIEW: 'CHECKOUT_HOSTED_PAYMENT_METHOD_PAGE_HIT',
  SELECT_PAYMENT_METHOD_CHECKOUT_HOSTED_PAYMENT_METHOD: 'SELECT_PAYMENT_METHOD_CHECKOUT_HOSTED_PAYMENT_METHOD_CLICK',
};
